import {
  REQUEST_USER_LOCATION,
  RECIEVE_USER_LOCATION,
  RECIEVE_USER_LOCATION_ERROR
} from '../actions'

import '../actions/userLocationActions'





// ============
// = Reducers =
// ============

const initState = {
  coords: null,
  station: null,
  lastUpdated: null,
  isFetching: false,
  error: null
}

function userLocationReducer(state=initState, action) {
  switch (action.type) {
  case REQUEST_USER_LOCATION:
    return {
      ...initState,
      isFetching: true
    }
  case RECIEVE_USER_LOCATION:
    return {
      ...initState,
      ...action.payload,
    }
  case RECIEVE_USER_LOCATION_ERROR:
    return {
      ...initState,
      error: action.error
    }
  default:
    return state
  }
}

export default userLocationReducer






// =============
// = Selectors =
// =============

export function userLocationSelector(state) {
  return state.userLocation
}



// WEBPACK FOOTER //
// ./src/reducers/userLocationReducer.js